<div
  class="modal fade"
  id="transactionLogModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="transactionLogModalLabel"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered" [ngClass]="['Service Request'].includes(headingTitle) ? 'modal-xl':'modal-lg'" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ headingTitle }} History - {{ this.itemName }}
        </h4>
        <button type="button" class="close">
          <img
            src="./assets/icons/close.svg"
            (click)="fnCloseModal()"
            alt="Close"
          />
        </button>
      </div>
      <div class="modal-body">
        <div class="data-section">
          <table class="table table-borderless row-border w-auto">
            <thead>
              <tr>
                <th *ngFor="let header of tableHeaders">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              @if(transactionLog.length && ['Invoice', 'Offer Letter', 'My Offer Letter', 'Expense', 'My Expense'].includes(headingTitle)){
              <tr *ngFor="let log of transactionLog">
                <td>
                  {{ log.time | date : "dd-MMM-YYYY, hh:mm a" | uppercase }}
                </td>
                <td
                  [ngStyle]="{
                    color: this.fnGetStatusColor(log.action),
                    'text-decoration': this.utilsService.fnGetTextDecoration(
                      log.action
                    )
                  }"
                  style="font-weight: 600"
                >
                  {{ log.action }}
                </td>
                <td
                  *ngIf="
                    [
                      'Offer Letter',
                      'My Offer Letter',
                      'My Expense',
                      'Expense'
                    ].includes(this.headingTitle)
                  "
                >
                  {{ log.level || "--" }}
                </td>
                <td>{{ log.user }}</td>
                <td [title]="log.comment || ''" class="copy-icon-cell">
                  {{ getLabel(log?.comment, 20) || "--" }}
                  <app-copy-button [data]="log"></app-copy-button>
              </td>
                    </tr>
                  } @else if(transactionLog.length &&
                  ['Service Request'].includes(headingTitle)){
                    <tr *ngFor="let log of transactionLog">
                <td>
                  {{
                    log?.time
                      ? (log.time | date : "dd-MMM-yyyy, hh:mm a" | uppercase)
                      : "--"
                  }}
                </td>
                <td
                  [ngStyle]="{
                    color: this.fnGetServiceRequestStatusColor(log.changeFrom),
                    'text-decoration': this.utilsService.fnGetTextDecoration(
                      log.changeFrom
                    )
                  }"
                  style="font-weight: 600"
                >
                  {{ log?.changeFrom?.toUpperCase() || "--" }}
                </td>
                <td
                  [ngStyle]="{
                    color: this.fnGetServiceRequestStatusColor(log.changeTo),
                    'text-decoration': this.utilsService.fnGetTextDecoration(
                      log.changeTo
                    )
                  }"
                  style="font-weight: 600"
                >
                  {{ log?.changeTo?.toUpperCase() || "--" }}
                </td>
                <td>{{ log?.user || "--" }}</td>
                <td [title]="log?.comment || ''" class="copy-icon-cell">
                  {{ getLabel(log?.comment, 20) || "--" }}
                  <app-copy-button [data]="log"></app-copy-button>
                </td>
              </tr>
              }
            </tbody>
          </table>
          <p style="text-align: center" *ngIf="transactionLog.length === 0">
            No History Found.
          </p>
        </div>
        <div class="button-cont p-3 py-0">
          <button
            type="button"
            class="btn btn-cancel btn-sm"
            (click)="fnCloseModal()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
